import React from 'react';
import {
    Newspaper,
    Disc,
    Award,
    Camera,
    Palmtree,
    Settings,
    Monitor,
    Image,
    Lock
} from 'lucide-react';

const DockItem = ({ label, icon: Icon, onClick, dot }) => (
    <button
        onClick={onClick}
        className="group relative flex flex-col items-center justify-center w-20 h-20 bg-[#e8e6df] active:bg-[#dcdad3] transition-all duration-100 ease-out"
    >
        {/* Button Bevel/Shadow - Braun Style */}
        <div className="absolute inset-0 shadow-[inset_1px_1px_0px_rgba(255,255,255,0.8),inset_-1px_-1px_0px_rgba(0,0,0,0.1)] group-active:shadow-[inset_2px_2px_4px_rgba(0,0,0,0.15),inset_-1px_-1px_0px_rgba(255,255,255,0.5)]"></div>

        {/* Separator Line (Right side) */}
        <div className="absolute right-0 top-2 bottom-2 w-[1px] bg-gradient-to-b from-transparent via-black/10 to-transparent group-last:hidden"></div>

        {/* Icon Container */}
        <div className="relative z-10 mb-1 transform group-hover:-translate-y-0.5 transition-transform duration-200">
            <div className="relative text-[#333333] drop-shadow-[0_1px_0_rgba(255,255,255,0.5)]">
                <Icon size={28} strokeWidth={1.5} />
                {dot && (
                    <div className="absolute -top-0.5 -right-1 w-1.5 h-1.5 bg-[#ff4400] rounded-full ring-1 ring-[#e8e6df]"></div>
                )}
            </div>
        </div>

        {/* Label */}
        <span className="relative z-10 text-[9px] font-sans font-bold uppercase tracking-wider text-[#444444] group-hover:text-black transition-colors">
            {label}
        </span>

        {/* Active Indicator Light (Optional detail) */}
        <div className="absolute top-2 right-2 w-1 h-1 rounded-full bg-black/10 group-active:bg-[#AF2E1B] transition-colors"></div>
    </button>
);

const Dock = ({ onOpenWindow, user, hasNewNews }) => {
    let items = [
        { id: 'welcome', label: 'Welcome', icon: Palmtree },
        { id: 'music', label: 'Music', icon: Disc },
        { id: 'video', label: 'Video', icon: Monitor },
        { id: 'images', label: 'Newsroom', icon: Newspaper },

        { id: 'photos', label: 'Photos', icon: Image },
        { id: 'members', label: 'Members', icon: Award },
        { id: 'instagram', label: 'Instagram', icon: Camera, link: 'https://www.instagram.com/welcometoparadise.us/' },
    ];

    // Executive Vault
    // Check for 'executive' tier specifically
    if (user?.membershipTier === 'executive') {
        items.push({ id: 'vault', label: 'Vault', icon: Lock });
    }

    items.push({ id: 'settings', label: 'Settings', icon: Settings });

    return (
        <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
            {/* Main Chassis */}
            <div className="bg-[#e8e6df] rounded-xl p-1.5 shadow-[0_20px_50px_-12px_rgba(0,0,0,0.5),0_0_0_1px_rgba(0,0,0,0.1),inset_0_1px_0_rgba(255,255,255,0.5)] flex items-center relative">

                {/* Inner Bevel */}
                <div className="absolute inset-0 rounded-xl border border-white/50 pointer-events-none"></div>

                {/* Button Container */}
                <div className="flex items-center bg-[#dcdad3] rounded-lg overflow-hidden shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] border border-black/5">
                    {items.map((item) => (
                        <DockItem
                            key={item.id}
                            label={item.label}
                            icon={item.icon}
                            onClick={() => item.link ? window.open(item.link, '_blank') : onOpenWindow(item.id)}
                            dot={item.id === 'images' && hasNewNews}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Dock;
